<template>
    <v-layout column align-center>
        <v-btn
            icon
            @click = "scroll_up"
        >
            <v-icon large>mdi-chevron-up</v-icon>
        </v-btn>
        <v-list
            dense
            ref="scroller"
            class="overflow-y-auto py-0 pl-3" 
            max-height="214"
            >
            <v-list-item-group
                v-model="selectedItem"
                mandatory
            >
                <v-list-item
                    v-for="(item, ind) in generateItems"
                    :key="ind"
                    ref="picker-item"
                    :disabled="limit && disabled_items[ind]"
                    >
                    {{ item }}
                </v-list-item>
            </v-list-item-group>
        </v-list>
        <v-btn
            icon
            @click="scroll_down"
        >
            <v-icon large>mdi-chevron-down</v-icon>
        </v-btn>
    </v-layout>
</template>

<script>

export default{
    props: {
        min:{
            type: Number,
            default: 0
        },
        max:{
            type: Number,
            default: function(){
                return this.count
            }
        },
        count:{
            type: Number,
        },
        label:{
            type: String
        },
        step:{
            type: Number,
            default: 1
        },
        value:{
            type: Number
        },
        limit:{
            type: Boolean,
            default: true
        }
    },
    data: ()=>({
        // selected: 0
    }),
    computed:{
        disabled_items(){
            let disabled_elements = this.generateItems.map(item => {
                return this.selectedInRange(item)
            })
            return disabled_elements
        },
        selectedItem:{
            set(v){
                this.$emit('input', this.generateItems[v])
            },
            get(){
                return this.generateItems.findIndex(item => item == this.value)
            }
        },
        generateItems(){
            let hrs = []
            for (let i = 0; i <= this.count; i+=this.step ) {
                hrs.push((''+i).length < 2 ? `0${i}` : `${i}` )
            }
            return hrs
        },
        scroll_bias(){
            let scroller = this.get_scroller()
            return scroller.clientHeight * 0.8
        },
        listHeight(){
            return this.$refs.scroller.$el.clientHeight
        }
    },
    methods: {
        selectListElement(){
            let scroller = this.get_scroller()

            let item = this.generateItems.findIndex(item => Number(item) == this.value)
            if(this.limit){
                if(!this.disabled_items[item]){
                    this.selectedItem = item
                }
            }
            scroller.scrollTo({left: 0, top: this.$refs['picker-item'][item].$el.offsetTop - 30, behavior: 'smooth'})
        },

        selectedInRange(item){
            let disabled;
            if(this.min > this.max){
                disabled = item > this.max && item < this.min
            }else{
                disabled = !(item <= this.max && item >= this.min)
            }
            return disabled 
        },

        get_scroller() {
            return this.$refs.scroller.$el
        },

        scroll_up(){
            let scroller = this.get_scroller()
            scroller.scrollTo({left: 0, top: scroller.scrollTop - this.scroll_bias, behavior: 'smooth'})
        },

        scroll_down(){
            let scroller = this.get_scroller()
            scroller.scrollTo({left: 0, top: scroller.scrollTop + this.scroll_bias, behavior: 'smooth'})
        },

    },
    mounted(){
        setTimeout(()=>{
            if(this.$refs['picker-item']){
                this.selectListElement()
            }
        }, 100)
    },
    watch: {
        value(){
            this.selectListElement()
        },
        max(){
            if(this.value > this.max){
                this.selectedItem = this.generateItems.findIndex(item => item <= this.max)
            }
        },
        min(){
            if(this.min > this.value){
                this.selectedItem = this.generateItems.findIndex(item => item >= this.min)
            }
        }
    }
}
</script>

